export enum ContainerType 
{
	Sequence = "sequence",
	Random = "random",
	Blend = "blend",
	Sound = "sound",
}